export  default {

  //заполнить данные по web пользователям
  loadRequests(state, data){
    state.requests=data;
  },

  loadById(state,data){
    if(data!=null){
      state.requests.push(data)
    }
  },

  //загружаем список ответов к заявке
  loadRequestAnswers(state,data){
    if(data!=null){
      state.requestAnswers=data;
    }
  },

  loadChatMessage(state, data){
    if(data!=null){}
    state.answerMessages=data;
  }
}
